import { GeneralSettingsBackend, IGeneralSettings } from '../../../types/settings'

export const convertEmptyValuesToNull = (
    data: IGeneralSettings | GeneralSettingsBackend
) => {
    if (!data || typeof data !== 'object') {
        return data
    }

    Object.entries(data).forEach(([key, value]) => {
        if (value === '') {
            // @ts-ignore
            data[key] = null
        }
    })
}